<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_vii"></a><span class="small">FOR JANE</span>,<br/>who understands me</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a7293604